import { OnInit, EventEmitter } from '@angular/core';
var CategorySelectorComponent = /** @class */ (function () {
    function CategorySelectorComponent() {
        this.runAnimation = true;
        this.title = 'Elegí la categoría';
        this.onClick = new EventEmitter();
        this.backToBranchClick = new EventEmitter();
    }
    CategorySelectorComponent.prototype.ngOnInit = function () {
    };
    CategorySelectorComponent.prototype.handleOnClick = function (event) {
        this.onClick.emit(event);
    };
    CategorySelectorComponent.prototype.handleBackToBranchClick = function (event) {
        this.backToBranchClick.emit(event);
    };
    return CategorySelectorComponent;
}());
export { CategorySelectorComponent };
